<template>
  <div class="reviewHDDT">
    <div class="header header-before">
      <div class="logo">
        <a href="#"><img src="@/pages/contract/review/img/Nextpay-logo-white.svg" /></a>
        <h1>Cảm ơn bạn tham gia đóng góp ý kiến để cải thiện chất lượng dịch vụ</h1>
      </div>
    </div>
    <!-- Main -->
    <div class="main">
      <div class="main-content">
        <div class="content">
          <span class="title-content">Đánh giá chất lượng của chuyên viên chăm sóc khách hàng</span>
          <div class="content-time">Thời gian chăm sóc từ : 24/03/2024 - 25/03/2024</div>
          <div class="rating">
            <ul class="list-star">
              <li
                v-for="star in maxStars"
                :class="{ active: star <= dataFeedBack.level }"
                :key="star"
                @click="rate(star)"
                class="star"
              >
                <i class="bx bx-star"></i>
              </li>
            </ul>
            <!-- <span v-if="hasCounter" class="counter">{{ counter }}</span> -->
          </div>
          <b-form-textarea
            id="textarea-large"
            size="lg"
            rows="8"
            v-model="dataFeedBack.note"
            placeholder="Hãy chia sẻ nhận xét của bạn về chất lượng tương tác chuyên viên NextPay nhé"
          ></b-form-textarea>
          <b-button @click="sendFeedback()" block variant="primary mt-3 p-2">Gửi đánh giá</b-button>
        </div>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { TicketService } from '../../services/ticket.service'

  export default {
    data() {
      return {
        maxStars: 5,
        ticketId: '',
        secretId: '',
        showLoading: false,
        dataFeedBack: {
          level: 0,
          note: '',
        },
      }
    },
    created() {
      this.ticketId = this.$route.params.ticketId
      this.secretId = this.$route.params.secretId
      this.getDetailFeedback()
    },
    methods: {
      async getDetailFeedback() {
        try {
          this.showLoading = true
          const params = {
            ticketId: this.ticketId,
            secretId: this.secretId,
          }
          const response = await TicketService.getDetailFeedback(params)
          if (response.code === 1000) {
            if (response.data.feedBackInformation) {
              this.dataFeedBack = response.data.feedBackInformation
            }
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      rate(star) {
        if (typeof star === 'number' && star <= this.maxStars && star >= 0) {
          this.dataFeedBack.level = this.dataFeedBack.level === star ? star - star : star
        }
      },
      async sendFeedback() {
        try {
          const params = {
            ticketId: this.ticketId,
            secretId: this.secretId,
            level: this.dataFeedBack.level,
            note: this.dataFeedBack.note,
          }
          const response = await TicketService.updateFeedback(params)
          if (response.code === 1000) {
            this.showSuccessMx('Gửi đánh giá thành công')
            this.getDetailFeedback()
          } else this.showFailMx(response.message)
        } catch (error) {
          this.showFailMx(error.message ?? error)
        }
      },
    },
  }
</script>

<style scoped>
  /*Header*/
  .header {
    background: #1765aa !important;
    position: relative !important;
  }
  .header-before:before {
    content: '' !important;
    position: absolute !important;
    left: 0 !important;
    right: 0 !important;
    background: #1765aa !important;
    width: 100% !important;
    height: 209px !important;
    top: 50px !important;
    z-index: -1 !important;
  }
  .logo {
    text-align: center !important;
    width: auto !important;
    padding: 15px 0 !important;
  }
  .logo a {
    display: inline-block !important;
    width: 130px !important;
  }
  .logo a img {
  }
  .logo h1 {
    color: #fff !important;
    margin-top: 16px !important;
    font-size: 24px !important;
    /*font-family: 'Roboto-Medium'*/
  }
  /*End Header*/

  .main {
    max-width: 800px !important;
    margin: 0 auto !important;
    background: #fff !important;
    border-radius: 5px !important;
    box-shadow: 0 0px 32px rgba(0, 0, 0, 0.06) !important;
  }
  .main-content {
    padding: 15px !important;
    background: #fafafa !important;
  }
  .content {
    text-align: center !important;
    padding: 50px 0px;
    display: block;
  }
  .title-content {
    font-weight: bold;
    font-size: 24px;
  }
  .content-time {
    padding: 10px;
    text-align: center !important;
    font-size: 16px;
  }
  .rating {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    text-align: center !important;
    margin: 20px auto;
    color: #a7a8a8;
  }

  .list-star {
    list-style-type: none;
    margin: 0 0 20px 0 !important;
    padding: 0 !important;
    font-size: 45px !important;
  }

  .star {
    display: inline-block;
    cursor: pointer;
    margin: 0 10px;
  }

  .star.active {
    color: #f3d23e;
  }

  .counter {
    color: #a7a8a8;
  }
</style>
